<template>
    <div class="agreement-wrapper">
        <Information name="privacyPolicy"/>
    </div>
</template>

<script>

import Information from '@/components/Information.vue'

export default {
    name: 'Privacy',
    components: {
        Information
    }
}
</script>
